import './custom.scss';
import './App.css';
import { BrowserRouter as Router, Route, Routes} from "react-router-dom";
import LayoutContainer from './containers/layout/Layout.container';
import Homepage from "./pages/home/Home.page";
import EventPage from "./pages/event/Event.page";
import ViewReportPage from "./pages/report/ViewReport.page";
import LoginPage from "./pages/auth/Login.page";
import SignupPage from "./pages/auth/Signup.page";
import ResetPasswordPage from "./pages/auth/ResetPassword.page";
import SetPasswordPage from "./pages/auth/SetPassword.page";
import ProtectedRoute from "./components/auth/ProtectedRoute.component";
import AuthRoute from "./components/auth/AuthRoute.component";
import NotFoundPage from "./pages/error/NotFound.page";
import CustomSnackbar from "./components/snackbar/Snackbar.component";
import VerifyAccountPage from "./pages/auth/VerifyAccount.page";
import ProfilePage from "./pages/profile/Profile.page";
import PingPage from "./pages/ping/Ping.page";
import ActivateAccountPage from "./pages/auth/ActivateAccount.page";
import DocumentPreviewPage from "./pages/event/DocumentPreview.page"
import ProtectedRedirectRoute from './components/auth/ProtectedRedirectRoute.component';
 
function App() {
  return (
    <div className="App">
          <>
            <CustomSnackbar />
            <Router>
              <Routes>
                <Route path="/" element={<LayoutContainer />}>
                      <Route index element={<ProtectedRoute><Homepage /></ProtectedRoute>} />

                      {/* <Route path="activate-account" element={<AuthRoute><ActivateAccountPage /></AuthRoute>} /> */}
                      <Route path="login" element={<AuthRoute><LoginPage /></AuthRoute>} />
                      <Route path="signup" element={<AuthRoute><SignupPage /></AuthRoute>} />
                      <Route path="verify-account" element={<AuthRoute><VerifyAccountPage /></AuthRoute>} />
                      <Route path="forgot-password" element={<AuthRoute><ResetPasswordPage /></AuthRoute>} />
                      <Route path="reset-password" element={<AuthRoute><SetPasswordPage /></AuthRoute>} />
                      <Route path="preview-document/:eventSlug/:documentId/:documentString" element={<ProtectedRoute><DocumentPreviewPage /></ProtectedRoute>} />
                      <Route exact path="event/:eventSlug" element={<ProtectedRoute><EventPage /></ProtectedRoute>} />
                      <Route exact path="candidate-report" element={<ProtectedRedirectRoute><ViewReportPage /></ProtectedRedirectRoute>} />
                      <Route exact path="profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
                      <Route exact path="ping" element={<PingPage />} />
                      <Route path="activate-account" element={<ActivateAccountPage />} />
                      <Route path='*' element={<NotFoundPage />} />
                </Route>
              </Routes>
            </Router>
          </>   
    </div>
  );
}

export default App;